<template>
  <div>
    <div>
      <div class="section">
        <div>
          <div class="section_image">
            <!-- Preview de IMG -->
            <div
              v-if="imageData[0] != undefined"
              style="position: relative; width: 12rem !important"
            >
              <div class="removeimage">
                <div class="closeimage" @click="resetFile(0)"></div>
              </div>
              <img
                v-if="
                  imageData[0].substring(0, 35) ==
                  'https://apirrimjpa.tutilabs.com.br/static/'
                "
                class="container"
                :src="`${imageData[0]}.webp`"
                id="fotoEmbalagemPreview"
                @click="clickPreview(imageData[0])"
              />
              <img
                v-else
                class="container"
                :src="`${imageData[0]}`"
                id="fotoEmbalagemPreview"
                @click="clickPreview(imageData[0])"
              />
            </div>

            <div class="image-preview" v-else>
              <div>
                <input
                  type="file"
                  accept="image/*"
                  id="fotoEmbalagem"
                  @change="previewFiles($event, 0)"
                  multiple
                  hidden
                />
                <label class="palavra" for="fotoEmbalagem">
                  <div class="palavra1"></div>
                </label>
              </div>
            </div>
            <div>
              <p class="title">Embalagem externa</p>
            </div>
            <div class="btn-group" v-if="imageData[0] != undefined">
              <input
                type="file"
                id="fotoEmbalagemEdit"
                @change="previewFiles($event, 0)"
                multiple
                hidden
                accept="image/*"
              />
              <label class="botao-editar" for="fotoEmbalagemEdit"> </label>
            </div>
          </div>
        </div>

        <div>
          <div class="section_image">
            <!-- Preview de IMG -->
            <div
              class="image-preview"
              v-if="imageData[1] != undefined"
              style="position: relative; width: 12rem !important"
            >
              <div class="removeimage">
                <div class="closeimage" @click="resetFile(1)"></div>
              </div>
              <img
                v-if="
                  imageData[1].substring(0, 35) ==
                  'https://apirrimjpa.tutilabs.com.br/static/'
                "
                class="container"
                :src="`${imageData[1]}.webp`"
                id="fotoEmbalagemPreview"
                alt=""
                @click="clickPreview(imageData[1])"
              />
              <img
                v-else
                class="container"
                :src="`${imageData[1]}`"
                id="fotoEmbalagemPreview"
                @click="clickPreview(imageData[1])"
              />
            </div>

            <div class="image-preview" v-else>
              <div>
                <input
                  type="file"
                  accept="image/*"
                  id="fotoEmbalagem1"
                  @change="previewFiles($event, 1)"
                  multiple
                  hidden
                />
                <label class="palavra" for="fotoEmbalagem1">
                  <div class="palavra1"></div>
                </label>
              </div>
            </div>
            <!--  -->

            <div>
              <p class="title">Embalagem interna</p>
              <div class="icons">
                <div class="btn-group" v-if="imageData[1] != undefined">
                  <label class="botao-editar" for="img-outrasFotosAberturaedit">
                  </label>
                  <input
                    type="file"
                    id="img-outrasFotosAberturaedit"
                    @change="previewFiles($event, 1)"
                    multiple
                    hidden
                    accept="image/*"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="section_image">
            <!-- Preview de IMG -->
            <div
              class="image-preview"
              v-if="imageData[2] != undefined"
              style="position: relative; width: 12rem !important"
            >
              <div class="removeimage">
                <div class="closeimage" @click="resetFile(2)"></div>
              </div>
              <img
                v-if="
                  imageData[2].substring(0, 35) ==
                  'https://apirrimjpa.tutilabs.com.br/static/'
                "
                @click="clickPreview(imageData[2])"
                class="container"
                :src="`${imageData[2]}.webp`"
                id="fotoEmbalagemPreview"
                alt=""
              />
              <img
                v-else
                class="container"
                :src="`${imageData[2]}`"
                id="fotoEmbalagemPreviewEdit"
                width="195"
                height="210"
                @click="clickPreview(imageData[2])"
              />
            </div>

            <div class="image-preview" v-else>
              <div>
                <input
                  type="file"
                  accept="image/*"
                  id="fotoEmbalagem2"
                  @change="previewFiles($event, 2)"
                  multiple
                  hidden
                />
                <label class="palavra" for="fotoEmbalagem2">
                  <div class="palavra1"></div>
                </label>
              </div>
            </div>
            <!--  -->

            <div class="card-body">
              <div>
                <div>
                  <input
                    type="text"
                    class="extra-input"
                    v-model="FormDataImages.fotoEmbalgemExtra.description"
                    placeholder="Insira um título"
                    accept="image/*"
                  />
                </div>

                <div class="btn-group" v-if="imageData[2] != undefined">
                  <label
                    class="botao-editar"
                    for="img-outrasFotosAbertura2edit"
                  ></label>
                  <input
                    type="file"
                    id="img-outrasFotosAbertura2edit"
                    @change="previewFiles($event, 2)"
                    multiple
                    hidden
                    accept="image/*"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // components: { InputI1 },

  props: {
    configInputs: Number,
  },
  async created() {
    await this.ConstructViewRRIM();
  },
  data() {
    return {
      typePreview: 0,
      mode_webp: [".webp", ""],

      srcImage: "",
      fotoEmbalagem: [],
      imageData: [],
      imagePreview: {
        fotoEmbalagemE: [],
        fotoEmbalagemI: [],
        fotoEmbalgemExtra: [],
      },
      FormDataImages: {
        fotoEmbalagemE: [],
        fotoEmbalagemI: [],
        fotoEmbalgemExtra: {
          file: [],
          description: [],
        },
      },
    };
  },
  watch: {
    FormDataImages: {
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        this.$store.commit("MutationImagesAberturaEmbalagem", newValue);
      },
    },
  },
  methods: {
    openModal(mySrc) {
      this.srcImage = mySrc;
    },
    clickPreview(base64) {
      this.$swal
        .fire({
          imageUrl: base64,
          imageAlt: "Imagem carregada",
          confirmButtonText: "Baixar",
          showCloseButton: true,
          background: "#fff",
          customClass: {
            popup: "preview-modal-popup",
            image: "preview-modal-image",
            confirmButton: "preview-modal-button",
          },
        })
        .then((result) => {
          if (result.isConfirmed) {
            const link = document.createElement("a");
            link.href = base64;
            link.download = "imagem.jpg";
            link.click();
          }
        });
    },
    async ConstructViewRRIM() {
      const dataQuery = await this.$store.getters.$GetDataAllRRIM;

      if (dataQuery.ImagesRRIM[0].IMG_EMB_EXT) {
        this.imageData[0] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_EMB_EXT}`;
        this.FormDataImages.fotoEmbalagemE =
          dataQuery.ImagesRRIM[0].IMG_EMB_EXT;
      }
      if (dataQuery.ImagesRRIM[0].IMG_EMB_INT) {
        this.imageData[1] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_EMB_INT}`;
        this.FormDataImages.fotoEmbalagemI =
          dataQuery.ImagesRRIM[0].IMG_EMB_INT;
      }

      if (dataQuery.ImagesRRIM[0].IMG_EMB_EXTRA) {
        this.imageData[2] =
          `${this.$store.state.ImgURL}` +
          `${dataQuery.ImagesRRIM[0].IMG_EMB_EXTRA}`;
        this.FormDataImages.fotoEmbalgemExtra.file =
          dataQuery.ImagesRRIM[0].IMG_EMB_EXTRA;
      }

      if (dataQuery.ImagesRRIM[0].IMG_EMB_EXTRA_DESC) {
        this.FormDataImages.fotoEmbalgemExtra.description =
          dataQuery.ImagesRRIM[0].IMG_EMB_EXTRA_DESC;
      }
    },
    previewFiles(event, position) {
      // Referência ao elemento de entrada DOM
      const input = event.target;

      // Certifique-se de que possui um arquivo antes de tentar lê-lo
      if (input.files && input.files[0]) {
        const file = input.files[0];

        if (!file.type.startsWith("image/")) {
          this.$swal.fire({
            icon: "error",
            title: "Arquivo inválido",
            text: "Por favor, selecione apenas arquivos de imagem.",
            confirmButtonColor: "#e74c3c",
          });
          input.value = "";
          return;
        }
        switch (position) {
          case 0:
            this.FormDataImages.fotoEmbalagemE = input.files[0];
            break;
          case 1:
            this.FormDataImages.fotoEmbalagemI = input.files[0];

            break;
          case 2:
            this.FormDataImages.fotoEmbalgemExtra.file = input.files[0];

            break;
        }
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // crie um novo FileReader para ler esta imagem e converter para o formato base64
        reader.onload = (e) => {
          // Note: função de seta usada aqui, de modo que "this.imageData" se refira ao componente imageData do Vue
          // Leia a imagem como base64 e defina como imageData
          this.imageData[position] = e.target.result;

          //Acionar $Emit para enviar o objeto quando um File for adicionado
        };
        reader.readAsDataURL(input.files[0]);
      }
      // Inicie o trabalho do leitor - leia o arquivo como url de dados (formato base64)
      //Identificando em qual contexto a imagem se encaixa
    },
    resetFile(position) {
      this.imageData[position] = null;

      switch (position) {
        case 0:
          this.FormDataImages.fotoEmbalagemE = [];
          break;
        case 1:
          this.FormDataImages.fotoEmbalagemI = [];
          break;
        case 2:
          this.FormDataImages.fotoEmbalgemExtra.file = [];
          this.FormDataImages.fotoEmbalgemExtra.description = "";
          break;
      }

      // this.$emit("setFotosAbertEmb",this.FormDataImages)
    },
  },
};
</script>
<style>
.swal2-popup.preview-modal-popup {
  height: 90vh !important;
  width: auto;
  max-width: 90vw;
  padding: 0.5rem 1.5rem !important;
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  border-radius: 1rem;
}
.swal2-image.preview-modal-image {
  max-width: 100%;
  max-height: 80%;
  height: 80%;
  width: auto;
  object-fit: contain;
  margin-bottom: 1rem;
  border-radius: 1rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.swal2-confirm.preview-modal-button {
  margin-top: auto;
  padding: 0.5rem 1.2rem;
  font-weight: 600;
  border-radius: 0.5rem;
  background-color: var(--font_color);
  width: 8rem;
}

.swal2-confirm.preview-modal-button:hover {
  color: var(--font_color);
  background-color: white;
}

.swal2-close {
  position: absolute !important;
  top: 0.2rem !important;
  right: 1rem !important;
  z-index: 10;
}
</style>
<style scoped>
.btn-group {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.swal2-popup.preview-modal-popup {
  height: 90vh !important;
  width: auto;
  max-width: 90vw;
  padding: 0.5rem 1.5rem !important;
  display: flex !important;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;
  border-radius: 1rem;
}
.swal2-image.preview-modal-image {
  max-width: 100%;
  max-height: 80%;
  height: 80%;
  width: auto;
  object-fit: contain;
  margin-bottom: 1rem;
  border-radius: 1rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.swal2-confirm.preview-modal-button {
  margin-top: auto;
  padding: 0.5rem 1.2rem;
  font-weight: 600;
  border-radius: 0.5rem;
  background-color: var(--font_color);
  width: 8rem;
}

.swal2-confirm.preview-modal-button:hover {
  color: var(--font_color);
  background-color: white;
}

.swal2-close {
  position: absolute !important;
  top: 0.2rem !important;
  right: 1rem !important;
  z-index: 10;
}
</style>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Faz o "zoom" sem distorcer */
  border-radius: 1rem;
  cursor: pointer;
}

.image-preview,
.palavra1,
#fotoEmbalagemPreview {
  width: 12rem !important;
  height: 12rem !important;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 1rem;
  overflow: hidden;
}

#fotoEmbalagemPreview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 1rem;
}

.section {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  flex-wrap: wrap;
  gap: 1rem;
}

.section_image {
  display: inline-block;
  max-width: 12rem !important;
}

.title {
  font-size: 0.7rem;
  font-weight: 600;
  font-family: "Poppins", sans-serif;
  margin-top: 0.5rem;
}

.palavra {
  width: 12rem !important;
}

.botao-editar {
  display: inline-block;
  padding: 0.5rem 1rem;
  background-color: white;
  background-image: url(../../../../../../static/icons/photo_camera_dark.svg) !important;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 70%;
  color: white;
  font-weight: 600;
  border: none;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: background-color 0.3s ease;
  font-family: "Poppins", sans-serif;
  width: 3rem;
  height: 3rem;
  border: 3px solid var(--font_color);
}

.botao-editar:hover {
  background-color: var(--font_color);
  border: none;
  background-image: url(../../../../../../static/icons/photo_camera_white.svg) !important;
}

.palavra1 {
  background-color: var(--bgProcess);
  background-image: url(../../../../../../static/icons/+_black.svg);
  width: 12rem !important;
  height: 12rem !important;
  border-radius: 1rem;
  cursor: pointer;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 15%;
}

.palavra1:hover {
  background-color: rgb(156, 150, 150);
}

.image-preview {
  position: relative;
}

.removeimage {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 3;
  cursor: pointer;
}

#fotoEmbalagemPreview {
  position: relative;
  z-index: 2;
  border-radius: 1rem;
}

.closeimage {
  width: 24px;
  height: 24px;
  background: url(../../../../../../static/icons/closeimage.svg) no-repeat
    center;
  background-size: contain;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
  cursor: pointer;
}

.extra-input {
  background-color: rgba(255, 255, 255, 0);
  padding: 0 !important;
  height: 1rem !important;
  border: none !important;
  color: var(--font_color);
  font-weight: 600;
  font-family: "Poppins", "sans-serif";
  border: 1px solid red;
}

.empty {
  background-image: url("../../../../../../static/icons/empty-image.png");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 40%;
  width: 12rem;
  height: 12rem;
  border: 2px solid #757575;
  border-radius: 1rem;
}

@media (max-width: 1266px) {
  .image-preview,
  .palavra1,
  #fotoEmbalagemPreview,
  .empty {
    width: 11rem !important;
    height: 11em !important;
  }
}

@media (max-width: 883px) {
}

@media (max-width: 500px) {
  .image-preview,
  .palavra1,
  #fotoEmbalagemPreview {
    width: 12rem !important;
    height: 12rem !important;
  }
}
</style>
